/* eslint-disable */
import VersionNumber from 'react-native-version-number'

export const stageConfig = {
  appDetails: {
    buildNumber: VersionNumber.buildVersion,
    bundleDisplayName: "Kargoe",
    userAgent : 'iOS React Kargoe',
    appVersion: VersionNumber.appVersion + '.' + VersionNumber.buildVersion,
    bundleId: "com.kargoe.kargoeapp",
    urlScheme: "kargoe",
    onScreenIdentifier: {
      label: 'staging',
      color: 'black',
      bgColor: 'gold',
    },
  },
  inAppPurchases: {
    productIds: [
      // 'com.example.coins100' 
      'com.kargoe.kargoeapp.kartoken100',
      'com.kargoe.kargoeapp.kartoken500', // these are stage & prod tokens
      'com.kargoe.kargoeapp.kartoken2000',
      'com.kargoe.kargoeapp.kartoken3700',
      'com.kargoe.kargoeapp.kartoken16500',
    ]  
  },

  BASE_URL_MEDIA: "https://s3.amazonaws.com/kargoe2-staging",
  BASE_URL_API: "https://staging-api.kargoe.com/webapi/",
  BASE_URL_ADMIN: "https://staging-admin.kargoe.com/",

  GOOGLE_GEOCODING_KEY: "AIzaSyAnYGK8WNE0AxOA5OdnkXBGiJPVJSjnP68", // these are Kargoe API keys
  GOOGLE_API_KEY: "AIzaSyBFrAWG1K6_ZYPsi6yLYx3hrGUhZb40joA",

  SHOPPABLE_API_URL: "https://api.shoppable.co/",

  ONE_SIGNAL_KEY: "1f976ec9-db65-45e6-a842-3684ec1a4fda", // kargoe
}
